import { createContext, useContext } from 'react';

import { ILocationDecoded } from '@mopla/data-models';
import { LatLng } from '@mopla/utils';

export interface IFetchPositionOptions {
	maximumAge?: number;
}

export interface IFetchPositionResult {
	coordinates: LatLng;
	address: ILocationDecoded | null;
}

export interface IGeoPositionContext {
	fetchCurrentPosition: (
		options?: IFetchPositionOptions
	) => Promise<IFetchPositionResult | null>;
	startWatchingPosition: () => Promise<void>;
	stopWatchingPosition: () => void;
}

export const GeoPositionContext = createContext<IGeoPositionContext | null>(
	null
);

export const useGeoPositionContext = () => {
	const context = useContext(GeoPositionContext);
	if (!context) {
		throw new Error(
			'useGeoPositionContext must be used within CurrentGeoPositionProviderV2'
		);
	}
	return context;
};
